var outdatedBrowserRework = require('outdated-browser-rework');

export default {
    init() {
      // JavaScript to be fired on all pages

      outdatedBrowserRework({
        browserSupport: {
          Chrome: 57, // Includes Chrome for mobile devices
          Edge: 39,
          Safari: 10,
          'Mobile Safari': 10,
          Firefox: 50,
          Opera: 50,
          Vivaldi: 1,
          // You could specify minor version too for those browsers that need it.
          Yandex: { major: 17, minor: 10 },
          // You could specify a version here if you still support IE in 2017.
          // You could also instead seriously consider what you're doing with your time and budget
          IE: false,
        },
        requireChromeOnAndroid: false,
        isUnknownBrowserOK: false,
        messages: {
          en: {
            // your own markup in the `update.web` message.
            url: 'https://bestvpn.org/outdatedbrowser',
          },
          fi: {
            // your own markup in the `update.web` message.
            url: 'https://bestvpn.org/outdatedbrowser/fi',
          },
        },
      });


      /*global FWP:true*/
      /* exported FWP */
      $(document).on('facetwp-loaded', function() {
        var querystring = FWP.build_query_string();
        if ( '' === querystring ) { // no facets are selected
            $('.facet-reset').hide();
        }
        else {
            $('.facet-reset').show();
        }
      });

      //Valikon avaava animaatio
      $('.hamburger').click(function () {
        $('.hamburger').toggleClass('hamburger--active');
        $('.site-header__menu-container').toggleClass('site-header__menu-container--open');
        $('html').toggleClass('navigation-open');
      });

      //Toinen valikko

      $('.logo-navigation').click(function () {
        $('.logo-navigation').toggleClass('button--active');
        $('.site-header__logomenu-container').toggleClass('site-header__logomenu-container--open');
        $('html').toggleClass('logonavigation-open');
      });


      $(window).on('resize', function () {
        if ($(window).width() > 1024) {
          $('.site-header__logomenu-container').removeClass('site-header__logomenu-container--open');
          $('.logo-navigation').removeClass('button--active');
          $('html').removeClass('logonavigation-open');
        } 
    });


      $(window).on('resize', function () {
          if ($(window).width() > 1024) {
            $('.site-header__menu-container').removeClass('site-header__menu-container--open');
            $('.hamburger').removeClass('hamburger--active');
            $('html').removeClass('navigation-open');
          } 
      });

      $(window).scroll(function() {
        var height = $(window).scrollTop();

        if (height > 50) {
          $('.site-header-background .information-wrapper').addClass('transform');
          $('.site-header-background').addClass('downheight');
        } else {
          $('.site-header-background .information-wrapper').removeClass('transform');
          $('.site-header-background').removeClass('downheight');
        }
      });


      // Poistetaan turhat dropdown luokat drilldown menulta
      $(window).on('resize', function() {
        if ($(window).width() < 1024) {
          $('.is-drilldown-submenu').removeClass('is-dropdown-submenu');
          $('.is-drilldown-submenu').removeClass('vertical');
          $('.is-drilldown-submenu').removeClass('first-sub');
        }
      });

      // Artikkelin fonttikoon muutokset buttoneille

      $('.btn-group').on('click', '.btn', function() {
        $(this).addClass('active').siblings().removeClass('active');
      });

      $('.small').on('click', function() {
        $('.entry-content p')
          .attr('class', '')
          .addClass($(this).data('size'));

          $('.entry-content-ingress')
          .attr('class', 'entry-content-ingress')
          .addClass($(this).data('size'));
      });

      $('.medium').on('click', function() {
        $('.entry-content p')
          .attr('class', '')
          .addClass($(this).data('size'));

          $('.entry-content-ingress')
          .attr('class', 'entry-content-ingress')
          .addClass($(this).data('size'));
      });

      $('.large').on('click', function() {
        $('.entry-content p')
          .attr('class', '')
          .addClass($(this).data('size'));

        $('.entry-content-ingress')
          .attr('class', 'entry-content-ingress')
          .addClass($(this).data('size'));
      });

      // Lisätään placeholder valinta Bike Park select-laatikkoon

      $('.glsr-field-assigned_terms .glsr-select').prepend($('<option>', {
        value: '',
        selected: 'selected',
        disabled: 'disabled',
        hidden: 'hidden',
        text: 'Valitse Bike Park',
    }));


      // Bannerkaruselli
      $('.banner-slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        focusOnSelect: true,
        infinite: true,
        draggable: true,
        autoplay: true,
        autoplaySpeed: 4000,
      });

      // Kuvakaruselli

      $('.gallery-row').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        focusOnSelect: true,
        infinite: false,
        draggable: false,
        autoplay: false,
        autoplaySpeed: 4000,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3,
              arrows: false,
            },
          },
        ],
      });

      $('#gallery-row-box').slickLightbox({
        src: 'src',
        itemSelector: '.gallery-item .gallery-image',
      });

      $('.resort-slope-map').slickLightbox({
        src: 'src',
        itemSelector: 'picture img',
      });

      $('.information-wrapper__image').slickLightbox({
        src: 'src',
        itemSelector: 'picture img',
      })


      // Videoupotuskaruselli

      $('.gallery-embed-row').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        focusOnSelect: true,
        infinite: false,
        draggable: false,
        autoplay: false,
        autoplaySpeed: 4000,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              arrows: false,
              slidesToShow: 1,
            },
          },
        ],
      });


      // Keskuskaruselli

      $('.resort-area__row').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
        arrows: true,
        focusOnSelect: true,
        infinite: false,
        draggable: true,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
            },
          },
        ],
      });

       // Uutiskategoria karuselli

    $('.category-news__row').slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: true,
      arrows: true,
      focusOnSelect: true,
      infinite: false,
      draggable: true,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    });

    // Seurakategoria karuselli

    $('.club-lifts__row').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      arrows: true,
      focusOnSelect: true,
      infinite: false,
      draggable: true,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    });

    // Urheilija karuselli

    $('.athlete-lifts__row').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      arrows: true,
      focusOnSelect: true,
      infinite: false,
      draggable: true,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    });

      // Liittyvät artikkelit

      $('.related-articles__row').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        focusOnSelect: true,
        infinite: false,
        draggable: true,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
            },
          },
        ],
      });

    },
    finalize() {

    },
  };



// WEBPACK FOOTER //
// ./scripts/routes/common.js